import React from "react";

const Loading = () => (
  <div className="fixed inset-0 z-50 grid place-items-center bg-white/70 px-4 backdrop-blur-sm">
    <div className="rounded-md border border-slate-200 bg-white px-5 py-4 text-center shadow-sm">
      <p className="text-sm font-bold uppercase text-purple-700">Loading</p>
      <p className="mt-1 text-sm text-gray-500">Preparing your mock test screen...</p>
    </div>
  </div>
);

export default Loading;
